import { 
  signInWithEmailAndPassword, 
  signOut, 
  User,
  onAuthStateChanged,
  GoogleAuthProvider,
  signInWithPopup
} from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { Teacher, Admin } from '../types';

export const loginWithEmail = async (email: string, password: string): Promise<Teacher | Admin | null> => {
  try {
    console.log('🔐 authService: Login başlatılıyor - Email:', email);
    
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    console.log('✅ authService: Firebase Auth başarılı - User ID:', user.uid);
    
    // Users collection'dan kullanıcı bilgilerini çek
    console.log('📡 authService: Users collection\'dan veri çekiliyor...');
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    
    console.log('📄 authService: User document var mı:', userDoc.exists());
    
    if (userDoc.exists()) {
      const userData = userDoc.data();
      console.log('👤 authService: User data:', userData);
      
      if (userData.status === 'teacher') {
        const teacher: Teacher = {
          id: user.uid,
          name: userData.Name,
          fenn: userData.fenn,
          status: userData.status,
          email: user.email || '',
          isActive: userData.isActive !== false
        };
        console.log('🎓 authService: Öğretmen bilgileri:', teacher);
        return teacher;
      } else if (userData.status === 'admin') {
        const admin: Admin = {
          id: user.uid,
          name: userData.Name,
          status: 'admin',
          email: user.email || ''
        };
        console.log('👑 authService: Admin bilgileri:', admin);
        return admin;
      } else {
        console.log('❌ authService: Geçersiz kullanıcı tipi - Status:', userData.status);
        throw new Error('Yalnız müəllimlər və adminlər daxil ola bilər');
      }
    } else {
      console.log('❌ authService: User document bulunamadı!');
      throw new Error('İstifadəçi məlumatları tapılmadı');
    }
  } catch (error: any) {
    console.error('❌ authService: Login hatası:', error);
    
    // Firebase hata kodlarını Azerbaycan diline çevir
    if (error.code === 'auth/invalid-credential') {
      throw new Error('İstifadəçi adı və ya şifrə yanlışdır');
    }
    if (error.code === 'auth/user-not-found') {
      throw new Error('İstifadəçi tapılmadı');
    }
    if (error.code === 'auth/wrong-password') {
      throw new Error('Şifrə yanlışdır');
    }
    if (error.code === 'auth/invalid-email') {
      throw new Error('Email formatı yanlışdır');
    }
    if (error.code === 'auth/user-disabled') {
      throw new Error('Bu istifadəçi hesabı deaktiv edilib');
    }
    if (error.code === 'auth/too-many-requests') {
      throw new Error('Çox sayda uğursuz cəhd. Bir qədər sonra yenidən cəhd edin');
    }
    if (error.code === 'auth/network-request-failed') {
      throw new Error('İnternet bağlantısı yoxdur');
    }
    
    // Eğer error zaten bir mesaj içeriyorsa, onu kullan
    if (error.message && !error.code) {
      throw error;
    }
    
    // Bilinmeyen hatalar için genel mesaj
    throw new Error('Daxil olarkən xəta baş verdi');
  }
};

export const loginWithGoogle = async (): Promise<Teacher | Admin | null> => {
  try {
    console.log('🔐 authService: Google ilə login başlanır');

    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
      // Mümkünsə yalnız istedad domenini prioritetləşdir
      //hd: 't.istedad21.edu.az',
      prompt: 'select_account'
    });

    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    console.log('✅ authService: Google Auth uğurlu - User ID:', user.uid);

    const userDoc = await getDoc(doc(db, 'users', user.uid));
    if (!userDoc.exists()) {
      throw new Error('Bu Google hesabı üçün istifadəçi məlumatları tapılmadı');
    }

    const userData = userDoc.data();
    console.log('👤 authService: Google user data:', userData);

    if (userData.status === 'teacher') {
      const teacher: Teacher = {
        id: user.uid,
        name: userData.Name,
        fenn: userData.fenn,
        status: userData.status,
        email: user.email || '',
        isActive: userData.isActive !== false
      };
      return teacher;
    } else if (userData.status === 'admin') {
      const admin: Admin = {
        id: user.uid,
        name: userData.Name,
        status: 'admin',
        email: user.email || ''
      };
      return admin;
    }

    throw new Error('Yalnız müəllimlər və adminlər daxil ola bilər');
  } catch (error: any) {
    console.error('❌ authService: Google login xətası:', error);

    if (error.code === 'auth/popup-closed-by-user') {
      throw new Error('Giriş pəncərəsi bağlandı');
    }
    if (error.code === 'auth/cancelled-popup-request') {
      throw new Error('Giriş əməliyyatı ləğv edildi');
    }

    if (error.message) {
      throw new Error(error.message);
    }

    throw new Error('Google ilə daxil olarkən xəta baş verdi');
  }
};

export const logout = async (): Promise<void> => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error('Logout hatası:', error);
    throw error;
  }
};

export const getCurrentUser = (): Promise<User | null> => {
  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });
};

export const onAuthStateChange = (callback: (user: User | null) => void) => {
  return onAuthStateChanged(auth, callback);
};
